import React from "react";
import Modal from "../../../components/ui/Modal/Modal";
import { Dropdown } from "../../../components/ui/Dropdown/Dropdown";
import { HiMagnifyingGlass } from "react-icons/hi2";
import Button from "../../../components/ui/Button/Button";
import RecipientTable from "./RecipientTable";
import {
  fetchHospitalMember,
  useHospitalMember,
} from "../../../api/auth/hospital-member/use-hospital-member";

const options = [
  { id: "name", name: "성명" },
  { id: "hospitalName", name: "병원명" },
  { id: "email", name: "아이디(이메일)" },
];

const SelectRecipient = ({ setRecipient, setTriggerCloseModal, recipient }) => {
  const [searchBy, setSearchBy] = React.useState("name");
  const [searchValue, setSearchValue] = React.useState("");
  const { data: memberList } = useHospitalMember(searchBy, searchValue);
  const [memberListData, setMemberListData] = React.useState(memberList?.data);
  const [selectedMember, setselectedMember] = React.useState([]);
  const [selectedBindedMember, setSelectedBindedMember] =
    React.useState(recipient);
  const handleSelectMember = (id) => {
    const index = selectedMember.indexOf(id);

    if (!selectedMember.includes(id)) {
      setselectedMember([...selectedMember, id]);
    }
    if (index > -1) {
      selectedMember.splice(index, 1);
      setselectedMember([...selectedMember]);
    }
  };
  const handleSelectBindedMember = (id) => {
    const index = selectedBindedMember.indexOf(id);

    if (!selectedBindedMember.includes(id)) {
      setSelectedBindedMember([...selectedBindedMember, id]);
    }
    if (index > -1) {
      selectedBindedMember.splice(index, 1);
      setSelectedBindedMember([...selectedBindedMember]);
    }
  };

  const handleBindMembers = () => {
    const binded = memberList?.data
      ?.filter((val) => selectedMember?.includes(val?.id))
      .map((res) => res);
    setSelectedBindedMember([...selectedBindedMember, ...binded]);
    // setMemberListData(
    //   memberListData
    //     ?.filter((res) => !selectedMember?.includes(res?.id))
    //     .map((res) => res)
    // );
    setselectedMember([]);
  };

  const handleDeleteBindedMember = (id) => {
    const deleted = selectedBindedMember
      ?.filter((val) => val?.id !== id)
      ?.map((res) => res);
    setSelectedBindedMember(deleted);
    // memberListData.push(deleted);
  };

  const handleDeleteAllBindedMember = async () => {
    setSelectedBindedMember([]);
    setMemberListData(memberList?.data);
  };

  const onSubmitBindedMember = () => {
    setRecipient(selectedBindedMember);
    setTriggerCloseModal(true);
  };

  const handleSearch = async (e) => {
    e.preventDefault();
    const res = await fetchHospitalMember(searchBy, searchValue);
    setMemberListData(res?.data);
  };

  const handleResetSearch = async () => {
    const res = await fetchHospitalMember();
    setMemberListData(res?.data);
    setSearchValue("");
  };

  return (
    <div>
      <div className="px-6">
        <p>1. 회원 목록</p>
        <div className="flex mt-2 gap-2 -mr-2 justify-between">
          <Dropdown
            width="w-32"
            options={options}
            height="h-10"
            positionDropdown={`top-12`}
            placeholder="성명"
            textColor="text-black px-4"
            onClickItem={(id) => setSearchBy(id)}
          />
          <form className="flex" onSubmit={handleSearch}>
            <input
              type="search"
              className={`w-[230px] text-black border-l border-t border-b border-button-grey rounded-l-[4px] p-2 focus:outline-0`}
              placeholder="수신할 관리자 정보 입력 후, 검색"
              onChange={(e) => setSearchValue(e.target.value)}
              value={searchValue}
            />
            <button
              type="submit"
              className="cursor-pointer flex items-center bg-[#19459f] px-4 py-2 border-r border-[#19459f] rounded-r-[4px]"
            >
              <HiMagnifyingGlass className="text-white text-[18px] m-auto" />
            </button>
          </form>
          <Button
            onClick={handleResetSearch}
            text="검색결과 초기화"
            borderColor="border-[#cccccc] border"
          />
        </div>
        <RecipientTable
          selectedMember={selectedMember}
          handleSelectMember={handleSelectMember}
          memberList={memberListData}
        />
        <div className="mt-4 w-full">
          <Button
            isDisabled={selectedMember?.length === 0}
            onClick={handleBindMembers}
            width="w-full"
            text={`수신 대상자 추가 +`}
            borderColor="border border-primary-blue"
            bgColor="bg-primary-blue"
            textColorDefault="text-white"
            disabledTextColor="text-white"
          />
        </div>

        <p className="mt-6">2. 수신 대상자 목록</p>

        <RecipientTable
          isBinded={true}
          memberList={selectedBindedMember}
          isCheckbox={false}
          handleSelectMember={handleSelectBindedMember}
          handleDeleteBindedMember={handleDeleteBindedMember}
        />

        <div className="flex text-[11px] justify-between mt-2">
          <p>
            ※ 수신 대상자로 지정할 회원을 선택 후, [수신 대상자 추가+]를 눌러{" "}
            <br />
            추가한 후 [선택완료]를 눌러주세요.
          </p>

          <Modal
            onSubmit={handleDeleteAllBindedMember}
            description={
              <div>
                수신 대상자로 추가된 명단을 전체 삭제하시겠습니까?
                <br />
                전체 삭제할 경우, 상단 리스트에서 체크된 정보가 초기화 됩니다.
              </div>
            }
          >
            <Button
              width="w-[10rem]"
              disabledTextColor="text-white"
              text={`수신 대상자 추가 - 전체삭제`}
              margin="mr-0"
              paddingButton="p-[4px]"
              isDisabled={selectedBindedMember?.length === 0}
            />
          </Modal>
        </div>
        <div className="mt-4">
          <Button
            onClick={onSubmitBindedMember}
            borderColor="border border-primary-blue"
            bgColor="bg-primary-blue"
            textColorDefault="text-white"
            width="w-full"
            className={`text-sm`}
            text={`선택완료`}
            disabledTextColor="text-white"
            isDisabled={selectedBindedMember?.length === 0}
            margin="mr-0"
            paddingButton="py-3"
          />
        </div>
      </div>
    </div>
  );
};

export default SelectRecipient;
